import React from 'react'
import * as S from './styles'

export type YoutubeVideoModalConfig = {
  videoId: string
}

type Props = {
  config: YoutubeVideoModalConfig
}

const YoutubeVideoModal = ({ config }: Props) => {
  if (!config?.videoId) return null

  return (
    <S.Container>
      <S.IframeWrapper>
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${config.videoId}?autoplay=1&rel=0`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </S.IframeWrapper>
    </S.Container>
  )
}

export default YoutubeVideoModal
